import styled, { keyframes, css } from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  @media (max-width: 768px) {
    justify-content: center;
    height: 100vh;
    width: 100vw;
    position: fixed;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  padding-top: 25px;
  padding-bottom: 25px;
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  height: 100%;
`;

export const VerificationContainer = styled.div`
  display: flex;
  height: 90%;

  flex-direction: column;
  padding: 4rem;
  border: 1px solid #ddd;
  margin-bottom: 20px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  gap: 20px;

  button {
    width: 14rem !important;
    svg {
      vertical-align: sub;
    }
  }

  img + p {
    font-weight: 700;
    font-size: 1.3rem;
  }

  p {
    width: 80%;
    text-align: center;
    line-height: 1.4rem;
  }

  a {
    color: ${(props) => props.theme.primary.light};
  }

  .custom-styles {
    --ReactInputVerificationCode-itemWidth: 2.5rem;
    --ReactInputVerificationCode-itemHeight: 3.5rem;
  }

  .custom-styles .ReactInputVerificationCode__item {
    position: relative;
    color: #262626;
    cursor: pointer;
    font-weight: 500;
  }

  .custom-styles .ReactInputVerificationCode__item,
  .custom-styles .ReactInputVerificationCode__item.is-active {
    box-shadow: none;
  }

  .custom-styles .ReactInputVerificationCode__item:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 2px;
    background-color: #cecece;
    transition: background-color 0.2s ease-out;
  }

  .custom-styles .ReactInputVerificationCode__item.is-active:after {
    background-color: ${(props) => props.theme.primary.light};
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 768px) {
    width: 100%;
    border: 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  width: 100%;

  button {
    width: 150px;
  }
`;
